import { FlexBox, Text } from '@dixa/lib-shared-habla';

import { ExpressionError, ScopeVariableSaveError } from 'apis/auditLogs';
import styles from './nodeErrors.module.scss';

type NodeErrorsProps = {
  expressionErrors?: readonly ExpressionError[] | null;
  scopeVariableSaveErrors?: readonly ScopeVariableSaveError[] | null;
};

export function NodeErrors({
  expressionErrors,
  scopeVariableSaveErrors,
}: NodeErrorsProps): JSX.Element | null {
  const errors = [
    ...(expressionErrors ?? []).map((error) => ({
      label: 'Expression error',
      errorType: error.error_type,
      message: error.message,
      code: error.expression,
    })),
    ...(scopeVariableSaveErrors ?? []).map((error) => ({
      label: 'Scope variable save error',
      errorType: error.error_type,
      message: error.message,
      code: error.variable_id,
    })),
  ];

  if (errors.length === 0) {
    return null;
  }

  return (
    <FlexBox gap="100" padding="0 0 0 100" alignItems="flex-start">
      <Text.Paragraph variant="2" subdued className={styles.connector}>
        └
      </Text.Paragraph>
      <FlexBox flexDirection="column" gap="200" className={styles.content}>
        {errors.map((error, index) => (
          <FlexBox key={index} flexDirection="column" gap="100">
            <Text.Paragraph variant="2" color="error" className={styles.error}>
              {error.label} · {error.errorType}: {error.message}
            </Text.Paragraph>
            <pre className={styles.codeBlock}>{error.code}</pre>
          </FlexBox>
        ))}
      </FlexBox>
    </FlexBox>
  );
}
